/**
 * Stili riutilizzabili per react-select
 * Utilizzare questi oggetti per mantenere consistenza negli stili delle Select
 */

// Stile base per menuPortal con z-index elevato
export const menuPortalStyles = {
  menuPortal: base => ({ 
    ...base, 
    zIndex: 9999 
  })
};

// Stili completi per Select con menu portal
export const selectWithPortalStyles = {
  menuPortal: base => ({ 
    ...base, 
    zIndex: 9999 
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999
  }),
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? '#007bff' : provided.borderColor,
    boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0, 123, 255, 0.25)' : provided.boxShadow,
    '&:hover': {
      borderColor: state.isFocused ? '#007bff' : '#adb5bd'
    }
  })
};

// Stili per Select multi-selezione
export const multiSelectStyles = {
  ...selectWithPortalStyles,
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e9ecef',
    borderRadius: '0.25rem'
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#495057',
    fontSize: '0.875rem'
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#6c757d',
    ':hover': {
      backgroundColor: '#dc3545',
      color: 'white'
    }
  })
};

// Configurazione comune per menuPortalTarget
export const menuPortalTarget = document.body;

// Oggetto completo per props comuni delle Select
export const commonSelectProps = {
  menuPortalTarget: document.body,
  styles: selectWithPortalStyles
};

// Props per Select multi-selezione
export const multiSelectProps = {
  menuPortalTarget: document.body,
  styles: multiSelectStyles,
  isMulti: true
};